import { Injectable } from "@angular/core";
import { ProjectConfigService } from "./project-config.service";
import { XtrasService } from "./xtras.service";
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { PageService } from "./page.service";
import { hexToRgb } from "../utils/color.utils";

@Injectable({
    providedIn: 'root'
})
export class InitializeAppService {

    constructor(
        private xServices: XtrasService,
        private projectConfig: ProjectConfigService,
        private gtmService: GoogleTagManagerService,
        private pageService: PageService,
        private router: Router,
    ) {
    }

    initializeApp() {
        const config = this.projectConfig.getConfig();
        this.pageService.updateMetadata({
            title: config.metadata.title,
            description: config.metadata.description,
            keywords: config.metadata.keywords,
            favicon: config.metadata.favicon
        });

        if(config.gtmId) {
            this.gtmService.addGtmToDom();
        }

        let { keyMap } = config;

        if(keyMap) {
            this.loadGoogleMaps(keyMap);
        }

        this.initializeConfig();

        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.updateAppClass(event.urlAfterRedirects);
        });
    }

    private loadGoogleMaps(apiKey: string): void {
        this.xServices.loadInlineScriptBody(`
            (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.\${c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                v: "weekly",
                key: "${apiKey}"
            });
        `);
    }

    private updateAppClass(url: string) {
        const webApp = document.querySelector('#cy-webapp');
        if (!webApp) return;

        webApp.classList.remove('bg_dark');
        webApp.classList.remove('bg_custom');

        const bgDarkRoutes = this.projectConfig.getConfig().bgDarkRoutes;
       // console.log(bgDarkRoutes);
        const bgCustomRoutes = this.projectConfig.getConfig().bgCustomRoutes;

        setTimeout(() => {
            const bgDark = bgDarkRoutes.some((route: string) => url.includes(route));
            const bgCustom = bgCustomRoutes.some((route: string) => url.includes(route));

            if (bgDark) {
              webApp.classList.add('bg_dark');
            } else if (bgCustom) {
                webApp.classList.add('bg_custom');
            }
        });
    }

    initializeConfig() {
        const globalConfig = this.projectConfig.getConfig();

        const root = document.documentElement;

        const colors = globalConfig?.colors || {};
        const fonts = globalConfig?.fonts || {};

        // Colors
        Object.entries(colors).forEach(([name, value]) => {
            if (value) {
                // Color normal
                root.style.setProperty(`--${name}-color`, value);

                // Versión RGB
                const rgb = hexToRgb(value);
                if (rgb) {
                    root.style.setProperty(`--rgb-${name}-color`, rgb);
                }
            }
        });

        // Fonts
        Object.entries(fonts).forEach(([name, value]) => {
            if (value) {
            root.style.setProperty(`--font-${name}`, value);
            }
        });

        if(globalConfig.styles) {
            const styles = document.createElement('style');
            styles.textContent = globalConfig.styles;
            document.head.appendChild(styles);
        }
    }
}
